<template>
  <div class="div-wapper">
    <div class="keywords">
      <span>总数:{{ reset.total || 0 }}</span>
    </div>

    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-collapse v-model="activeId" accordion @change="onGetDownId">
          <van-collapse-item v-for="item in list" :key="item.id" :name="item.id">
            <template #title>
              <van-image width="40" height="40" :src="item.avatar" />
              <span class="nickname">{{ item.nickname }}</span>
              <span class="first-count">{{ reset2.total || '' }}</span>
            </template>

            <van-list
              v-model="loading2"
              :finished="finished2"
              finished-text="没有更多了"
              @load="onLoad2"
            >
              <van-cell class="second-item" v-for="item in list2" :key="item.id">
                <template #title>
                  <van-image width="40" height="40" :src="item.avatar" />
                  <span class="nickname">{{ item.nickname }}</span>
                </template>
              </van-cell>
            </van-list>
          </van-collapse-item>
        </van-collapse>
      </van-list>
    </div>
  </div>
</template>

<script>
import { getMemberSubordinate } from '@/api/api-user';

export default {
  data() {
    return {
      activeId: '',
      downId: '',

      page: 1,
      list: [],
      reset: {},
      loading: false,
      finished: false,

      page2: 1,
      list2: [],
      reset2: {},
      loading2: false,
      finished2: false,
    };
  },
  methods: {
    async onGet() {
      this.loading = true;
      try {
        const { data, ...reset } = await getMemberSubordinate({ page: this.page });
        this.reset = reset;
        this.list = this.list.concat(data || []);
        this.loading = false;
        if (this.reset.last_page <= this.page) {
          this.finished = true;
        } else {
          this.page += 1;
        }
      } catch (error) {}
    },
    onLoad() {
      this.list = [];
      this.onGet();
    },
    onGetDownId(id) {
      this.downId = id;
      this.onLoad2();
    },
    async onGetDown(id) {
      if (id) {
        try {
          const { data, ...reset2 } = await getMemberSubordinate({ page: this.page2, id });
          this.reset2 = reset2;
          this.list2 = this.list2.concat(data || []);
          this.loading2 = false;
          if (this.reset2.last_page <= this.page2) {
            this.finished2 = true;
          } else {
            this.page2 += 1;
          }
        } catch {}
      } else {
        this.reset2 = {};
        this.list2 = [];
      }
    },
    onLoad2() {
      this.list2 = [];
      this.onGetDown(this.downId);
    },
  },
};
</script>
<style lang="less" scoped>
.div-wapper {
  .keywords {
    width: 100%;
    line-height: 40px;
    position: fixed;
    left: 16px;
    top: 0;
    z-index: 3;
    background-color: white;
  }
  .list {
    position: relative;
    top: 40px;
  }
  /deep/ .second-item {
    padding: 0 16px;
  }
  /deep/ .van-cell__title {
    position: relative;
    height: 40px;
  }
  /deep/ .van-icon {
    line-height: 40px;
  }
  .nickname {
    position: absolute;
    height: 40px;
    line-height: 40px;
    margin-left: 8px;
    font-size: 20px;
  }
  .first-count {
    position: absolute;
    height: 40px;
    line-height: 40px;
    right: 0;
    margin-right: 8px;
    font-size: 20px;
  }
}
</style>
